const ApuracaoContratoSamsung = () => import('@/spa/apuracao-contrato-samsung/ApuracaoContrato');

export default {
  path: 'apuracao-contrato-samsung',
  name: 'apuracao-contrato-samsung',
  component: ApuracaoContratoSamsung,
};
